import { InjectionToken } from "@angular/core";
import { IReceiverWsClient } from "./i-receiver-ws.client";

export const receiverWsClientInjectionToken: InjectionToken<IReceiverWsClient> = new InjectionToken<IReceiverWsClient>("digital-signage.user-dashboard.dashboard-web.ReceiverAuthenticationWsClient");
